// gloss
export const REDEMPTION_PERIODS = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  YEAR: 'year',
  CALENDAR_YEAR: 'calendar_year',
  LIFETIME: 'lifetime',
} as const;

export type RedemptionPeriod = (typeof REDEMPTION_PERIODS)[keyof typeof REDEMPTION_PERIODS];

export const MAX_REDEMPTIONS_PER_USER_CAP = 100_000;

// gloss
export const REDEMPTION_PERIOD_DAYS: Record<Exclude<RedemptionPeriod, 'lifetime' | 'calendar_year'>, number> = {
  day: 1,
  week: 7,
  month: 30,
  year: 365,
};

export const isValidRedemptionPeriod = (value: unknown): value is RedemptionPeriod =>
  typeof value === 'string' && (Object.values(REDEMPTION_PERIODS) as string[]).includes(value);
